// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Domain-editor-DomainEditor-module__container";
var _2 = "webpack-concepts-Extraction-Blocks-Domain-editor-DomainEditor-module__judgementItem";
var _3 = "webpack-concepts-Extraction-Blocks-Domain-editor-DomainEditor-module__judgementItemDash";
var _4 = "webpack-concepts-Extraction-Blocks-Domain-editor-DomainEditor-module__judgementList";
export { _1 as "container", _2 as "judgementItem", _3 as "judgementItemDash", _4 as "judgementList" }
